export default __webpack_public_path__ + "static/media/symbol.ae3731e3.svg";